const ProductCard = ({ product = {}, removeProduct } = {}) => {
    const { imageURLs, name, barcode } = product;

    const handleClick = () => {
        removeProduct && removeProduct(barcode);
    }

    if (!barcode) {
        return null;
    }

    return (
        <>
            <div className="container">
                <div className="card">
                    <div className="card-image">
                        <figure className="image is-3by4">
                            <img src={imageURLs && imageURLs[0]} alt={name} />
                        </figure>
                    </div>
                    <div className="card-content">
                        <p className="title is-4">{name}</p>
                        <p className="subtitle is-6">{barcode}</p>
                    </div>

                    <footer className="card-footer">
                        <button disabled={!removeProduct} className="button is-fullwidth"
                            onClick={handleClick}
                        >
                            <span className="icon">
                                <i className="fas fa-trash" />
                            </span>
                        </button>
                    </footer>
                </div>
            </div>
        </>
    );
}

export default ProductCard;
